<template>
  <div class="exampleFoot">
    <!-- <a href="http://" target="_blank" rel="noopener noreferrer">asdad</a> -->
    <div
      class="imgWrap"
      ref="imgWrap"
      @mouseenter="imgHover = true"
      @mouseleave="imgHover=false"
      @mousemove="mousemove"
    >
      <router-link to="/">
        <img v-show="!imgHover" class="itemImg" :src="footImg" alt="回到顶部">
        <img v-show="imgHover" class="itemImg" :src="footImg2" alt="回到顶部" @click="goTop">
        <span v-show="imgHover" class="tip-text" style="width:100px;pointer-events:none;">
          <img ref="followText" class="back" src="./img/top.png" alt="">
        </span>
      </router-link>
    </div>
  </div>
</template>
<script>
import Bus from "store/bus.js";
export default {
  data() {
    return {
      footImg: require("common/image/home/footImg.png"),
      footImg2: require("common/image/home/footImg2.png"),
      imgHover: false
    };
  },
  methods: {
    goTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      // Bus.$emit("scroll-top");
    },
    mouseenter() {
      this.imgHover = true;
    },
    mouseleave() {
      this.imgHover = false;
    },
    mousemove(e) {
      if (!this.imgHover) {
        return;
      }
      let dom = this.$refs["followText"];
      let wrapDom = this.$refs["imgWrap"];
      if (!dom) {
        return;
      }
      let wrapDetail = wrapDom.getBoundingClientRect();
      dom.style.top = e.y - wrapDetail.top + 13 + "px";
      dom.style.left = e.x - wrapDetail.left + 13 + "px";
    }
  }
};
</script>
<style lang="scss" scoped>
.exampleFoot {
  width: 45px;
  margin: 80px auto 30px;
  .imgWrap {
    position: relative;
    display: inline-block;
    img {
      cursor: pointer;
      width: 44px;
      height: 44px;
    }
    .back {
      width: 70px;
      height: 22px;
      top: 50%;
      position: absolute;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/novo-gotop/index.vue